import bScrollspy from './scrollspy';
import { registerDirectives, vueUse } from '../../utils/plugins';

var directives = {
  bScrollspy: bScrollspy
};

var VuePlugin = {
  install: function install(Vue) {
    registerDirectives(Vue, directives);
  }
};

vueUse(VuePlugin);

export default VuePlugin;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/directives/scrollspy/index.js
// module id = 680
// module chunks = 0